module.exports = __webpack_public_path__ + "static/media/73.b9f9793d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/73.svg
// module id = 168
// module chunks = 0